import { gql } from 'apollo-angular';

export const updateFichierOperationCommentMutation = gql`
  mutation updateFichierOperationCommentaire($fichierOperationId: ID!, $commentaire: String!) {
    updateFichierOperationCommentaire(fichierOperationId: $fichierOperationId, commentaire: $commentaire) {
      commentaire
    }
  }
`;
